import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useMailchimpConfigurationQuery = createQueryHook(
  CreatorIntegrationsApiClient.getMailchimpConfiguration,
  {
    queryKey: ['mailchimpConfiguration'],
  },
)
